/**
 * Config entity keys that are metadata, never content: the legacy open-time
 * `accessedAt` stamp and the server-owned `modifiedAt` stamp. Neither counts as
 * an unpublished change, triggers autosave, or appears in the publish review.
 * `modifiedAt` is metadata only on flows and widgets (`isStampedEntityPath`);
 * elsewhere, such as campaign attributes, it is ordinary content.
 */
export const VOLATILE_CONFIG_KEYS: readonly string[] = ['accessedAt', 'modifiedAt']

/** Whether a jsondiffpatch key trail points at one flow or widget: `rightCta.{offerFunnels,widgets}[i]`. */
export function isStampedEntityPath(path: readonly string[]): boolean {
  const [root, collection, index] = path
  return (
    path.length === 3 &&
    root === 'rightCta' &&
    (collection === 'offerFunnels' || collection === 'widgets') &&
    /^\d+$/.test(index ?? '')
  )
}
